import React from 'react'
import { Box, Text } from 'pcln-design-system'
import styled from 'styled-components'
import { Modal } from 'pcln-modal'
import Form from '../../Hotels/SearchForm/Form'
import { HOTEL_FORM_STATE_TYPE, PromoDealType } from '../../Hotels/types'

type PromoModalType = {
  ariaLabel: string
  isModalOpen: boolean
  onClose: () => void
  isMobile: boolean
  primaryText: string
  secondaryText: string
  onSubmit: (data: HOTEL_FORM_STATE_TYPE) => void
  promoDeal: PromoDealType
}

const StyledModal = styled(Modal)<{ zIndex: number }>`
  && {
    max-width: 100%;
  }
  // This is required for form elements like typeahead and calendar to work correctly in mobile view
  button[title='close'] {
    z-index: ${props => props.zIndex};
  }
`

const handleTransition = (transitionState: any) => `
  transition: transform 0.3s linear;
  transform: ${
    transitionState === 'entered' ? `translateY(0px);` : 'translateY(-120%);'
  }
`

export default function PromoModal({
  ariaLabel,
  isModalOpen,
  onClose,
  isMobile,
  primaryText,
  secondaryText,
  onSubmit,
  promoDeal
}: PromoModalType) {
  return (
    <StyledModal
      enableOverflow
      ariaLabel={ariaLabel}
      isOpen={isModalOpen}
      onClose={onClose}
      width={[1, 750]}
      timeout={50}
      dialogAnimation={isMobile ? handleTransition : undefined}
      imgMode={isMobile ? true : undefined}
      verticalAlignment={isMobile ? 'top' : 'middle'}
      zIndex={isMobile ? 1 : undefined}
    >
      <Box p={[3, 0]}>
        <Box px={[0, 3]}>
          <Text
            color="text"
            fontSize={[3, null, null, 5]}
            fontWeight="bold"
            style={{ lineHeight: 1.25 }}
          >
            {primaryText}
          </Text>
          <Text
            color="text"
            fontSize={[1, null, null, 4]}
            style={{ lineHeight: 1.25 }}
            mb={3}
          >
            {secondaryText}
          </Text>
          <Box pb={4}>
            <Form onSubmit={onSubmit} promoDeal={promoDeal} />
          </Box>
        </Box>
      </Box>
    </StyledModal>
  )
}
